import { useCallback } from 'react';

import { AppContainer } from 'twyne-new.ui'

import { useGlobalAuthStore } from '@Stores/global/auth';

import Routes from './Routes';
import Sidebar from './Sidebar';
import { CustomReportProvider } from './views/custom/store';

export default function ReportLayout() {
  const { auth: { menuPermissions } } = useGlobalAuthStore()
  const permission = menuPermissions.map(menu => menu.key);

  const hasPermission = useCallback(mod => permission.includes(mod), [permission])

  return (
    <CustomReportProvider>
      <AppContainer className='max-md:min-h-0'>
        <Sidebar hasPermission={hasPermission} />
        <Routes hasPermission={hasPermission} />
      </AppContainer>
    </CustomReportProvider>
  )
}
